module.exports = __webpack_public_path__ + "685dad57bdb7946e2b8eef7935cdbe5f.gif";